import { useContext } from 'react'

import RecommendationTeaserContext, {
  RecommendationTeaserContextType,
} from '@contexts/recommendationTeaser'

const useIsRecommendationTeaser = (): RecommendationTeaserContextType =>
  useContext(RecommendationTeaserContext)

export default useIsRecommendationTeaser
